import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import AllMetricsContextProvider from './context/AllMetricsContext';
import SelectedMetricsContextProvider from './context/SelectedMetricsContext';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import makeApolloClient from './Components/common/makeApolloClient';
import ChartContextProvider from './context/ChartContext';

const theme = createMuiTheme({
  typography: {
    fontFamily: `'Lab Grotesque', sans-serif`,
    weight: {
      black: 900,
      bold: 600,
      default: 200
    }
  },
  color: {
    black: '#38393c',
    blue: '#1387ba',
    gray: '#747474',
    lightgray: '#ebebeb',
    lightgray2: '#f1f1f1',
    lightgray3: '#f7f7f7',
    red: '#e91019'
  }
});

let apolloClient = null;

const Main = () => {
  const [isAuthed, setIsAuthed] = useState(true);
  apolloClient = apolloClient || makeApolloClient(setIsAuthed);

  return (
    <ThemeProvider theme={theme}>
      <ApolloHooksProvider client={apolloClient}>
        <AllMetricsContextProvider>
          <SelectedMetricsContextProvider>
            <ChartContextProvider>
              <App isAuthed={isAuthed} />
            </ChartContextProvider>
          </SelectedMetricsContextProvider>
        </AllMetricsContextProvider>
      </ApolloHooksProvider>
    </ThemeProvider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));
